"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PocketEntryStatus = exports.PocketEntryType = exports.BalanceStatus = void 0;
/* Pocket company balances */
var BalanceStatus;
(function (BalanceStatus) {
    BalanceStatus["OUTSTANDING"] = "OUTSTANDING";
    BalanceStatus["SETTLED"] = "SETTLED";
})(BalanceStatus = exports.BalanceStatus || (exports.BalanceStatus = {}));
/* Pocket employee entries */
var PocketEntryType;
(function (PocketEntryType) {
    PocketEntryType["EXPENSE"] = "EXPENSE";
    PocketEntryType["TRANSFER"] = "TRANSFER";
})(PocketEntryType = exports.PocketEntryType || (exports.PocketEntryType = {}));
var PocketEntryStatus;
(function (PocketEntryStatus) {
    PocketEntryStatus["APPROVED"] = "APPROVED";
    PocketEntryStatus["AWAITING_REVIEW"] = "AWAITING_REVIEW";
    PocketEntryStatus["NOT_OK"] = "NOT_OK";
})(PocketEntryStatus = exports.PocketEntryStatus || (exports.PocketEntryStatus = {}));
//# sourceMappingURL=pocket.js.map